import { IonChip, IonCol, IonIcon, IonItem, IonLabel, IonRow, IonText } from "@ionic/react";
import { isShiftPriorityValid } from "@src/app/utils/shiftHelper";
import { logEvent } from "@src/appV2/lib/analytics";
import { ShiftChip, getHasShiftColor } from "@src/lib/deprecatedCode";
import { cloudy, cloudyNight, moon, partlySunny } from "ionicons/icons";
import { FC } from "react";

import { GroupItemDescriptionProps, GroupItemProps } from "./model";
import { USER_EVENTS } from "../../constants/userEvents";
import { getFriendsDayViewSummary } from "../components/workWithFriends/utils";

enum ShiftTypeWorkingDescription {
  am = "You are working an AM shift",
  pm = "You are working a PM shift",
  noc = "You are working an NOC shift",
}

const getShiftIcon = (shiftName: string) => {
  switch (shiftName) {
    case "am":
      return partlySunny;
    case "pm":
      return cloudyNight;
    case "noc":
      return moon;
    default:
      return cloudy;
  }
};

const GroupItemDescription: FC<GroupItemDescriptionProps> = ({
  shiftName,
  myShiftLength,
  openShiftLength,
}) => {
  let color = "medium";
  let description = "No open shifts";

  if (myShiftLength > 0) {
    color = "success";
    description = ShiftTypeWorkingDescription[shiftName];
  } else if (openShiftLength > 0) {
    color = "dark";
    description = `${openShiftLength} open ${shiftName.toUpperCase()} shifts`;
  }

  return (
    <IonText color={color}>
      <p>{description}</p>
    </IonText>
  );
};

export const GroupItem: FC<GroupItemProps> = ({
  shiftName,
  myShiftMap,
  openShiftMap,
  onClick,
  friendsList,
}) => {
  const myShiftLength = myShiftMap[shiftName]?.length ?? 0;
  const openShiftLength = openShiftMap[shiftName]?.length ?? 0;

  const isButton = myShiftLength > 0 || openShiftLength > 0;

  const onShiftItemClick = () => {
    isButton && onClick(shiftName);
    logEvent(USER_EVENTS.VIEWED_CALENDAR_DATE_SHIFTS, { shiftName: shiftName });
  };

  const hasPriorityShift =
    openShiftLength > 0 &&
    openShiftMap[shiftName]?.some(
      (shift) => shift.priorityTill && isShiftPriorityValid(shift.priorityTill)
    );
  const hasShift = {
    hasStaffedShift: myShiftLength > 0,
    hasOpenShift: openShiftLength > 0,
    hasPriorityShift,
  };

  const friendsDescription = friendsList && getFriendsDayViewSummary(friendsList);

  return (
    <IonItem button={isButton} onClick={onShiftItemClick} detail={isButton}>
      <IonIcon
        icon={getShiftIcon(shiftName)}
        mode="ios"
        color={getHasShiftColor(hasShift, shiftName, true)}
        slot="start"
      />
      <IonLabel>
        <IonRow className="ion-align-items-end ion-wrap">
          <IonCol size="2" className="ion-no-padding">
            <ShiftChip name={shiftName} hasShift={hasShift} outline={true} />
          </IonCol>
          {hasShift.hasStaffedShift === false && hasPriorityShift && (
            <IonCol size="10" className="ion-no-padding">
              <IonChip color="shift-priority" className="small-chip">
                Priority Access shifts available
              </IonChip>
            </IonCol>
          )}
        </IonRow>
        <GroupItemDescription
          myShiftLength={myShiftLength}
          openShiftLength={openShiftLength}
          shiftName={shiftName}
        />
        {friendsDescription && <p>{friendsDescription}</p>}
      </IonLabel>
    </IonItem>
  );
};
